import { Card, CardBody, CardImg, CardTitle } from 'reactstrap';
import LoadingSpiner from '../components/LoadingSpiner';

import articleImg from './../../assets/images/package.png';
import { useDashboardStats } from '../../Api/queriesDashboard';
import { useNavigate } from 'react-router-dom';
import { connectedUserRole } from '../Authentication/userInfos';

export default function TotalArticleSansStock() {
  const {
    data: stats,
    isLoading: statsLoading,
    error: statsError,
  } = useDashboardStats();
  const navigate = useNavigate();

  const handleNavigate = () => {
    return navigate('/produit_no_stock');
  };

  return (
    <div
      onClick={() => connectedUserRole === 'admin' && handleNavigate()}
      style={{ cursor: 'pointer' }}
    >
      {statsLoading && <LoadingSpiner />}
      {!statsError && !statsLoading && (
        <Card
          style={{
            height: '180px',
            boxShadow: '1px 0px 10px rgba(1, 186, 186, 0.57)',
          }}
        >
          <CardImg
            src={articleImg}
            alt='articles'
            style={{ height: '90px', objectFit: 'contain' }}
          />
          <CardBody>
            <CardTitle className='text-center'>
              <span className='text-danger fs-5'>
                {stats?.produits?.stockFaible ?? 0}
              </span>
              <p>Produits En Stock Faible</p>
            </CardTitle>
          </CardBody>
        </Card>
      )}
    </div>
  );
}
